import { IconArrowDown } from '@tabler/icons-react';
import { useRichTextEditorContext } from '@mantine/tiptap';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { canSplitTableDown } from 'pages/revisions-module/template-editor/editors/template/extensions/table-split';

/**
 * Splits the current table below the focused cell row.
 */
export default function TableSplitDown({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      label="Rozdeliť tabuľku dole"
      icon={<IconArrowDown />}
      disabled={!canSplitTableDown(editor.state)}
      onClick={() => editor.chain().focus().splitTableDown().run()}
    />
  );
}
